import { useQuery, useMutation, useQueryClient } from "react-query";
import { getIODetail, updateIO, bulkUpdateIOOAs, deleteIO } from "@/api/Histories/io-api";

const key = "io-detail";

export function useIODetail(historyId, options = {}) {
	return useQuery([key, historyId], () => getIODetail(historyId), {
		enabled: Boolean(historyId),
		staleTime: 0,
		...options,
	});
}

export function useIOUpdate(listType = null, filters = null) {
	const queryClient = useQueryClient();

	return useMutation(({ historyId, application }) => updateIO(historyId, application, listType, filters), {
		onSuccess: (response, variables) => {
			if (response?.updated_data) {
				const { data, total } = response.updated_data;

				queryClient.setQueryData(["histories", "list", listType, filters], (oldData) => {
					if (!oldData) return { data, total };
					return { ...oldData, data, total };
				});
			}

			queryClient.setQueryData(["io-detail", variables.historyId], variables.application);
		},
	});
}

export function useIOBulkUpdate(listType = null, filters = null) {
	const queryClient = useQueryClient();

	return useMutation(({ ids, idsOAs }) => bulkUpdateIOOAs(ids, idsOAs, listType, filters), {
		onSuccess: (response) => {
			if (response?.updated_data) {
				const { data, total } = response.updated_data;

				queryClient.setQueryData(["histories", "list", listType, filters], (oldData) => {
					if (!oldData) return { data, total };
					return { ...oldData, data, total };
				});
			}
		},
	});
}

export function useIODelete(listType = null, filters = null) {
	const queryClient = useQueryClient();

	return useMutation((historyId) => deleteIO({ selected: historyId, listType, filters }), {
		onSuccess: (response) => {
			if (response?.updated_data && listType && filters) {
				const { data, total } = response.updated_data;

				queryClient.setQueryData(["histories", "list", listType, filters], (oldData) => {
					if (!oldData) return { data, total };
					return { ...oldData, data, total };
				});
			} else {
				queryClient.invalidateQueries(["histories"]);
			}
		},
	});
}
